let config: { [key: string]: any } = {
  API: {
    NEWSLETTER: "/api/newsletter",
    SEARCH: "/api/search/simple",
    TOOL_SEARCH: "/api/search/tools",
    TOOLBOX_SEARCH: "/api/search/sub-tools",
  },
};

const env = process.env.REACT_APP_WIENI_ENV;

switch (env) {
  case "development": {
    config = {
      ...config,
    };
    break;
  }
  case "staging": {
    config = {
      ...config,
    };
    break;
  }
  // production is the default config, if passing REACT_APP_WIENI_ENV value fails
  default:
  case "production": {
    config = {
      ...config,
    };
    break;
  }
}

export default Object.freeze(config);
